import React from 'react';
import {executeQuery} from "../../requests/executeQuery";
import dollars from "../../dollar-format";
import {HSC_PIPELINE_FEES} from "../../consts/queries";
import {HscPipelineFeesModel, HscPipelineFeesTotals} from "./hscPipelineFeesModel";
import {columns, totalColumns} from "./columns";
import PipelineTable from "../PipelineTable";
import {startYearHscFees} from "../../consts/consts";
import {formatPipelineTitle, normalizeListQuery} from "../../utils";
import hscTeamMembers from '../../hsc-team-members';
import filter from '../../filter';
import Dropdown from '../Dropdown/Dropdown';

export default class HscPipelineFees extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: [],
            loading: true,
            totals: [],
            title: 'Closed',
            teamMembers:'',
            hscquery:{},
            query:{}
        }
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    }

    componentDidMount() {
    
        let hscquery={
            HSC_TEAM_MEMBERS:''
        };
       const normalizedQuery = normalizeListQuery(this.props.location.query);
       this.setState({query: normalizedQuery},()=>{
        this.fetch(this.props.routeParams.status);

       })
        let member = normalizedQuery.HSC_TEAM_MEMBERS && normalizedQuery.HSC_TEAM_MEMBERS.split(",") || [];
        const memberList = hscTeamMembers.filter((e)=>{
            return member.indexOf(e.EMAIL)>=0;
        })
        memberList.map((el, index)=>{
            hscquery.HSC_TEAM_MEMBERS += el ? index === hscTeamMembers.length-1 ? el.EMAIL:el.EMAIL+',' : '';
        })
        this.setState({hscquery});   
    }

    handleChangeDropdown(hscquery, optionType, value, valueKey){
        hscquery.HSC_TEAM_MEMBERS = hscquery[valueKey];
        const _query =this.state.query;
        _query.HSC_TEAM_MEMBERS = hscquery[valueKey];
        this.setState({hscquery, query:_query},()=>{
            this.fetch(this.props.routeParams.status);
        })
    }
    fetch(id) {
        this.setState({loading: true});
        let teamMembers=[],teamMembersNames=[];
        const teamMemberEmails = this.state.query.HSC_TEAM_MEMBERS ? this.state.query.HSC_TEAM_MEMBERS.split(',') : '';
        if(teamMemberEmails)
            teamMemberEmails.map((teamMemberEmail) => teamMembers.push(hscTeamMembers.find(el => el.EMAIL === teamMemberEmail)));
        teamMembers.map(teamMember => teamMembersNames.push(teamMember.NAME))

        let year = id && id.split('-')[1] !== 'ytd' ? id.split('-')[1] : new Date().getFullYear();
        let y = year;

        const query = {
            HSC_STATUS: 'Closed',
            YEAR: year,
            HSC_TEAM_MEMBERS:this.state.query.HSC_TEAM_MEMBERS ? this.state.query.HSC_TEAM_MEMBERS : '',
            order:'LOAN_CLOSING_DATE.asc'
        }
        if(id == 'total-closed'){
            delete query.YEAR;
        }
        const options = filter(query, 'hscPipelineFees');

        const requests = [
            executeQuery({
                queryName: HSC_PIPELINE_FEES,
                options
            }),
        ];

        while(y > startYearHscFees) {

            let q = {
                HSC_STATUS: 'Closed',
                YEAR: --y,
                HSC_TEAM_MEMBERS: this.state.query.HSC_TEAM_MEMBERS ? this.state.query.HSC_TEAM_MEMBERS : '',
                order:'LOAN_CLOSING_DATE.asc'
            }
            let options = filter(q, 'hscPipelineFees');

            requests.push(executeQuery({
                queryName: HSC_PIPELINE_FEES,
                options
            }));
        }

        const teamMembersSubtitle = teamMembersNames ? (teamMembersNames.length > 1 ? teamMembersNames[0]+', '+teamMembersNames[1] : teamMembersNames[0]) : null; 
        Promise.all(requests).then(res => {
            const state = {
                loading: false,
                title: formatPipelineTitle(id),
                rows: [],
                totals: [],
                teamMembers: teamMembersSubtitle
            };
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) && res[0].data.length) {
                res[0].data.map((row, index) => {
                    const previousCumulative = index > 0 ? state.rows[index-1].cumulative : 0;
                    
                    //both agents selected -> base HSC_LIST_FEE (100%)
                    //one agent selected -> compute new HSC_LIST_FEE based on agent percentage
                    if(teamMemberEmails && teamMemberEmails.length < 2){
                        if(row.HSC_TEAM_MEMBER_1 === teamMemberEmails[0])
                            row.HSC_LIST_FEE = row.HSC_LIST_FEE * row.HSC_TEAM_MEMBER_1_PERCENT/100;
                        else if(row.HSC_TEAM_MEMBER_2 === teamMemberEmails[0])
                            row.HSC_LIST_FEE = row.HSC_LIST_FEE * row.HSC_TEAM_MEMBER_2_PERCENT/100;
                    }

                    state.rows.push(new HscPipelineFeesModel({data: row, previousCumulative, location: this.props.location}));
                });
                state.rows.push(new HscPipelineFeesModel({data: state.rows, isTotal: true, year, location: this.props.location}));
            }

            state.totals.push(new HscPipelineFeesTotals({data: state.rows, year, isCurrentYear: true, location: this.props.location}));
            for (let index = 1; index < res.length; index++) {
                if (res[index] && res[index].data){
                    let data = res[index].data;

                    data.map((row, i) => {                     
                        const previousCumulative = i > 0 ? data[i-1].cumulative : 0;

                        if(teamMemberEmails && teamMemberEmails.length < 2){
                            if(row.HSC_TEAM_MEMBER_1 === teamMemberEmails[0])
                                row.HSC_LIST_FEE = row.HSC_LIST_FEE * row.HSC_TEAM_MEMBER_1_PERCENT/100;
                            else if(row.HSC_TEAM_MEMBER_2 === teamMemberEmails[0])
                                row.HSC_LIST_FEE = row.HSC_LIST_FEE * row.HSC_TEAM_MEMBER_2_PERCENT/100;
                        }
                        row.cumulative = row.HSC_LIST_FEE ? parseFloat(row.HSC_LIST_FEE) + previousCumulative : previousCumulative;
                    });
                    state.totals.push(new HscPipelineFeesTotals({data: data, year: --year, location: this.props.location}));
                }
            }
            state.totals.push(new HscPipelineFeesTotals({data: state.totals, isTotal: true, location: this.props.location}));
            this.setState(state);
        }).catch(() => {
            this.setState({
                loading: false,
                rows: [],
                totals: [],
                title: formatPipelineTitle(id),
            });
        });
    }

    render() {
        const {rows, totals, loading, title, teamMembers} = this.state;
        return (
            <div className='HscPipelineFees'>
                <div className='title-row'>
                    <div className="Pipeline_head_left">
                        <h3 className='h3'>{title} </h3>
                        <h4 className='h3'>
                            Transactions : {loading ? '…' : Math.max(0, rows.length - 1)}
                        </h4>
                        <h4 className='h3'>
                            Loan Amount : {loading ? '…' : (totals && totals.length ? dollars(totals[0].loanAmount) : dollars(0))}
                        </h4>
                    </div>
                     <div className='Pipeline_head_right'>
                            <Dropdown
                                dropdownType='multiple'
                                optionsType='team-members'
                                optionLabelKey='NAME'
                                optionKey='EMAIL'
                                value={this.state.hscquery.HSC_TEAM_MEMBERS}
                                label='Agent'
                                valueKey='HSC_TEAM_MEMBERS'
                                data={this.state.hscquery}
                                handleParentChange={this.handleChangeDropdown}
                            />  
                        </div>
                </div>
                {
                    loading ?
                        <div className='loading'>Loading data...</div>
                        :
                        <div className={`${teamMembers ? 'with-agent':''}`}>
                            <PipelineTable rows={rows} columns={columns} hasTotalRow={true} className='list' />
                            {title == "Total Closed" && <PipelineTable rows={totals} columns={totalColumns} hasTotalRow={true} className='totals' />}
                        </div>
                }
            </div>
        );
    }
}